export default (theme) => ({
    root: {
        backgroundColor: theme.colors.actionMinor[50],
        padding: 24,
        boxSizing: 'border-box',
    },
    canvas: {
        display: 'flex',
        flexFlow: 'column nowrap',
        maxWidth: '100%',
        backgroundColor: theme.colors.primary.white,
        border: `1px solid ${theme.colors.grey[100]}`,
        borderRadius: 6,
        padding: '48px 32px',
        margin: 'auto',
    },
    logo: {
        marginBottom: 36,
        flexShrink: 0,
        maxWidth: 300,
    },
    header: {
        textAlign: 'left',
        marginBottom: 24,
        '& > * + *': {
            marginTop: 8,
        },
    },
    checkboxGroup: {
        marginTop: 24,
    },
    formActions: {
        display: 'flex',
        flexFlow: 'row nowrap',
        alignItems: 'center',
        justifyContent: 'flex-end',
        gap: 12,
        marginTop: 60,
    },
    formActionsLink: {
        marginRight: 'auto',
        whiteSpace: 'pre',
    },
    link: {
        color: theme.colors.actionMajor[500],
        fontSize: 'inherit',
        lineHeight: 'inherit',
        '&:hover': {
            color: theme.colors.actionMajor[600],
        },
    },
    advice: {
        marginBottom: 8,
    },
    policies: {
        marginTop: 0,
    },
});
